import { CometChat } from "@cometchat/chat-sdk-javascript";

export const checkIfUserIsBlocked = (blockedUsers: CometChat.User[], uid: string) => {
  return blockedUsers.some((user) => user.getUid() === uid);
}